/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import {
  Form,
  Col,
  Row,
  Input,
  Table,
  Button,
  Modal,
} from "antd";
import { CreateRecallModal } from "./create-modal";
import { EditRecallModal } from "./edit-modal";
import { useState } from "react";
import type { ColumnsType } from "antd/es/table";
import { Routes } from "../../../../../../AppRoutes";
import { useHistory } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { PlanningDepartmentRecallToolService } from "../../../../../../services/planning-department/recall-tool";
import { Upload, Checkbox } from "antd";
import { IToolType } from "../../models";
import { eContent } from "../../constant/field-names";
import { validatePhoneNumber } from "../../../../../../services/util";
import { downloadExcel } from "react-export-table-to-excel";
import { useRouteMatch } from "react-router-dom";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";
import { HiOutlineTrash } from "react-icons/hi2";
import type { UploadFile, UploadProps } from "antd/es/upload/interface";
import ExcelJS from "exceljs";
import _ from "lodash";

export function EditRecallToolForm() {
  const [dataSource, setDataSource] = useState<any[]>([]);
  const history = useHistory();
  const [form] = Form.useForm();
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [listDelete, setListDelete] = useState<number[]>([]);
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const { id } = useRouteMatch().params as any;

  const initialData = async () => {
    const data = await PlanningDepartmentRecallToolService.getDetail(id);
    form.setFieldsValue({
      ePhoneNumber: data?.fields?.ePhoneNumber || "",
      eApprovedBy: data?.fields?.eApprovedBy,
      pickedUser: data?.fields?.pickedUser,
    });
    let listTools = [];
    try {
      listTools = JSON.parse(data?.fields?.eContent);
    } catch (error) {}
    setDataSource(listTools);
  };

  useEffect(() => {
    initialData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns: ColumnsType<IToolType> = [
    {
      title: isMultiDelete ? (
        <Checkbox
          onClick={(e: any) => {
            if (e.target.checked) {
              setListDelete(_.range(0, dataSource.length));
            } else {
              setListDelete([]);
            }
          }}
        />
      ) : (
        ""
      ),
      dataIndex: "action",
      key: "action",
      render: (index: number) => {
        index = (currentPage - 1) * pageSize + index;

        if (isMultiDelete) {
          return (
            <Checkbox
              checked={listDelete.includes(index)}
              onChange={(e) => {
                if (e.target.checked) {
                  let newListDelete = [...listDelete, index];
                  setListDelete(newListDelete);
                } else {
                  let newListDelete = [...listDelete];
                  newListDelete = newListDelete.filter(
                    (value): any => value != index
                  );
                  setListDelete(newListDelete);
                }
              }}
            />
          );
        }

        return (
          <div className="flex">
            <EditRecallModal
              dataSource={dataSource}
              setDataSource={setDataSource}
              index={index}
            />

            <Button
              onClick={() => {
                if ((dataSource.length - 1) % 10 == 0) {
                  const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
                  if (currentPage >= 2 && currentPage === NUM_PAGES) {
                    setCurrentPage(currentPage - 1);
                  }
                }

                setDataSource((prev: any) => {
                  return prev.filter(
                    (value: any, indexValue: number) => indexValue != index
                  );
                });
              }}
              className="ml-1"
            >
              <HiOutlineTrash
                size={20}
                className="cursor-pointer"
                color="#dc2626"
              />
            </Button>
          </div>
        );
      },
    },
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      render: (value: any, record: IToolType, index: number) => (
        <>{(currentPage - 1) * pageSize + index + 1}</>
      ),
    },
    {
      title: "Tên CCDC",
      dataIndex: eContent.toolName,
      key: eContent.toolName,
    },
    {
      title: "Mã CCDC",
      dataIndex: eContent.toolId,
      key: eContent.toolId,
    },
    {
      title: "ĐVT",
      dataIndex: eContent.Dram,
      key: eContent.Dram,
    },
    {
      title: "Số lượng",
      dataIndex: eContent.Quantity,
      key: eContent.Quantity,
    },
    {
      title: "Lý do",
      dataIndex: eContent.reason,
      key: eContent.reason,
    },
  ];

  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: async (file) => {
      const workbook = new ExcelJS.Workbook();
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = async () => {
        const buffer: any = reader.result;
        const workbooks = await workbook.xlsx.load(buffer);

        let data: any[] = [];

        workbooks.eachSheet((sheet, sheetId) => {
          sheet.eachRow((row: any, rowIndex) => {
            data.push([...row.values].filter((value, index) => index != 0));
          });
        });

        data = data.filter((value, index) => index != 0);

        const dataSource: any[] = [];

        for (const item of data) {
          if (!Array.isArray(item) || item.length != 5) {
            CreateNotification({
              title: "Import file thất bại",
              body: `Vui lòng download biểu mẫu và nhập đúng thông tin.`,
              icon: "/icons/error.png",
            });
            return;
          }

          dataSource.push({
            [eContent.toolName]: item[0],
            [eContent.toolId]: item[1],
            [eContent.Dram]: item[2],
            [eContent.Quantity]: item[3],
            [eContent.reason]: item[4],
          });
        }

        setDataSource((prev) => [...prev, ...dataSource]);

        setFileList([...fileList, file]);
      };

      return false;
    },
    fileList,
    showUploadList: false,
  };

  const onFinish = async (values: any) => {
    if (dataSource.length === 0) {
      CreateNotification({
        title: "Thất bại",
        body: `Chỉnh sửa thất bại.`,
        icon: "/icons/error.png",
      });
      return;
    }

    try {
      // const resp = await PlanningDepartmentRecallToolService.updateRequest(id, {
      //   ePhoneNumber: values.ePhoneNumber,
      //   eContent: JSON.stringify(dataSource),
      // });

      CreateNotification({
        title: "Thành công",
        body: `Cập nhật phiếu yêu cầu thu hồi CCDC thành công`,
        icon: "/icons/success.png",
      });

      history.push(Routes.procedureRecallTool.path);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Cập nhật yêu cầu thu hồi CCDC thất bại`,
        icon: "/icons/success.png",
      });

      history.push(Routes.procedureRecallTool.path);
    }
  };

  const downLoad = () => {
    const header = ["Tên CCDC", "Mã CCDC", "ĐVT", "Số lượng", "Lí do"];
    const body: any[] = [];

    downloadExcel({
      fileName: "Thu hồi CCDC",
      sheet: "1",
      tablePayload: {
        header,
        body: body,
      },
    });
  };

  const confirmDelete = () => {
    const NUM_PAGES = Math.ceil(dataSource.length / pageSize);
    if (currentPage >= 2 && currentPage === NUM_PAGES)
      setCurrentPage(currentPage - 1);

    let newDataSource = [...dataSource];
    newDataSource = newDataSource.filter(
      (_, index) => !listDelete.includes(index)
    );
    setDataSource(newDataSource);
    setListDelete([]);
    setIsMultiDelete(false);
  };

  const showDeleteConfirm = () => {
    Modal.confirm({
      title: "Thông báo",
      content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
      okText: "Xác nhận",
      okType: "danger",
      okButtonProps: { type: "primary" },
      cancelText: "Huỷ",
      onOk() {
        confirmDelete();
      },
    });
  };

  const pageSize = 10; // Number of rows per page
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <>
      <Form onFinish={onFinish} size="large" form={form}>
        <Row gutter={[32, 0]}>
          <Col span={12}>
            <StyledTitle level={5}>
              Số điện thoại <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item
              name="ePhoneNumber"
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (validatePhoneNumber(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Số điện thoại không hợp lệ.")
                    );
                  },
                }),
              ]}
            >
              <Input className="font-weight-normal" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col>
            <StyledTitle level={5}>
              Danh mục CCDC cần thu hồi <span className="text-danger">(*)</span>
            </StyledTitle>
          </Col>
        </Row>

        <Row>
          <Col>
            <CreateRecallModal
              dataSource={dataSource}
              setDataSource={setDataSource}
            />
          </Col>

          <Col>
            {!isMultiDelete && (
              <StyledButton
                bgColor="red"
                className="ml-3"
                type="primary"
                danger
                onClick={() => setIsMultiDelete(true)}
              >
                Chọn nhiều để xóa
              </StyledButton>
            )}

            {isMultiDelete && (
              <StyledButton
                className="ml-3"
                bgColor="green"
                onClick={() => {
                  setIsMultiDelete(false);
                  setListDelete([]);
                }}
              >
                Quay lại
              </StyledButton>
            )}

            {listDelete.length != 0 && (
              <StyledButton
                bgColor="red"
                className="ml-3"
                type="primary"
                danger
                onClick={() => {
                  showDeleteConfirm();
                }}
              >
                Xóa dữ liệu đã chọn
              </StyledButton>
            )}
          </Col>

          <Col>
            <Upload {...props}>
              <StyledButton bgColor="blue" className="mx-3 ">
                Tải biểu mẫu
              </StyledButton>
            </Upload>
          </Col>

          <Col span={8}>
            <div className="mt-1">
              <a href="#" className="text-primar" onClick={downLoad}>
                Download biểu mẫu tại đây
              </a>
            </div>
          </Col>
        </Row>

        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={{
            onChange: (page) => {
              setCurrentPage(page);
            },
            current: currentPage,
          }}
          scroll={{
            x: "100vh",
          }}
        />

        <Row gutter={[32, 0]}>
          <Col span={24}>
            <div className="d-flex justify-content-center">
              <StyledButton
                bgColor="red"
                htmlType="submit"
                onClick={() => history.push(Routes.procedureRecallTool.path)}
                type="primary"
                danger
              >
                Hủy
              </StyledButton>

              <StyledButton
                bgColor="yellow"
                type="primary"
                htmlType="submit"
                className="ml-3"
              >
                Xác nhận
              </StyledButton>
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
}
